import {
    createAsyncAction,
    createStandardAction,
} from "typesafe-actions";
import { IClip } from "../api";

export const saveClipRequest = createStandardAction('SAVE_CLIP_REQUEST')<IClip>();
export const saveClipSuccess = createStandardAction('SAVE_CLIP_SUCCESS')<IClip>();
export const saveClipFailure = createStandardAction('SAVE_CLIP_FAILURE')<Error, IClip>();

export const listClips = createAsyncAction(
    'LIST_CLIPS_REQUEST',
    'LIST_CLIPS_SUCCESS',
    'LIST_CLIPS_FAILURE',
)<void, IClip[], Error>();



// WEBPACK FOOTER //
// ./src/actions/clipActions.ts